'use strict';

import videojs from 'video.js';
import ScrollReveal from 'scrollreveal';

const isSafari = navigator.vendor &&
                 navigator.vendor.indexOf('Apple') > -1 &&
                 navigator.userAgent &&
                 !navigator.userAgent.match('CriOS');

const KEYCODE_ESC = 27;

export default function workVideos() {
  const $btnOpenVideo = $('.js-open-video');
  const $btnCloseVideo = $('.js-close-video');

  $btnOpenVideo.on('click', function(event) {
    event.preventDefault();
    const videoId = $(this).attr('data-video-id');

    videojs(`video--${videoId}`).play()

    // ugly hack for safari
    if (isSafari) {
      setTimeout(() => {
        videojs(`video--${videoId}`).play()
      }, 300)
    }

    $(`.modal-video#${videoId}`).addClass('is-active');
    $('html').addClass('no-scroll');
  });

  $btnCloseVideo.on('click', function(event) {
    event.preventDefault();
    $(this).parent('.modal-video').removeClass('is-active');
    $('html').removeClass('no-scroll');
    const videoId = $(this).parent('.modal-video').attr('id');
    videojs(`video--${videoId}`).currentTime(0).pause();
  });

  // close modal if esc key pressed
  $(document).keyup(function(event) {
    if (event.which === KEYCODE_ESC) {
      $btnCloseVideo.click();
    }
  });

  // Video listing scroll-reveal
  // =========================
  let scrollReveal = ScrollReveal();

  if (!scrollReveal.isSupported()) {
    $('html').addClass('no-scrollreveal');
  }

  scrollReveal.reveal('.work-grid__list__item', {
    delay: 200,
    duration: 400,
    distance: '2rem',
    easing: 'cubic-bezier(0.455, 0.030, 0.515, 0.955)',
    opacity: 0,
    scale: 1
  });

}



// WEBPACK FOOTER //
// ./workVideos.js